export type ISegmentType =
    | "property_object_classification"
    | "lease_contract_role"

export interface ISegmentConfig {
    label: string
    chipColor: string
    paths: string[]
}

export const SEGMENT_CONFIGS: Record<ISegmentType, ISegmentConfig> = {
    property_object_classification: {
        label: "segment-picker.selected.object-types",
        chipColor: "#245B51",
        paths: [
            "notice-board",
            "content-items",
            "embedded-integrations",
            "forms",
            "community",
            "information-items",
            "chatbot/dispatches",
            "product-catalogue/products",
            "template-feature",
        ],
    },
    lease_contract_role: {
        label: "segment-picker.selected.tenant-types",
        chipColor: "#245B51",
        paths: [
            "notice-board",
            "content-items",
            "embedded-integrations",
            "forms",
            "community",
            "information-items",
            "chatbot/dispatches",
            "product-catalogue/products",
            "template-feature",
        ],
    },
}
